export const learningHoursApiHandler = {
  getOrganizationLearningHours: {
    method: "GET",
    path: () => `org-learning-hours-management`
  },
  createLearningHours: {
    method: "POST",
    path: () => `org-learning-hours-management`
  },
  deleteLearningHours: {
    method: "DELETE",
    path: (payload: { id: string | number }) => `org-learning-hours-management/${payload.id}`
  }
};